export const variables = {
  spacer: 8
}
